export default {
  // 新订单详情
  all: '全部',
  toPay: '待支付',
  toDispatch: '待发货',
  inTransit: '在途',
  completed: '已完成',
  canceled: '已取消',
  rejected: '已拒收',
  inTransitStatus: '在途状态',
  toPickupByLogistics: '待物流收件',
  pickedUpByLogistics: '物流已收件',
  orderTime: '下单时间',
  paymentTime: '支付时间',
  dispatchTime: '发货时间',
  completeTime: '完成时间',
  noLimit: '不限',
  today: '今天',
  yesterday: '昨天',
  recent7Days: '最近7天',
  recent30Days: '最近30天',
  orderNumber: '订单编号',
  billNumber: '支付批次号',
  buyerID: '买家编号',
  skuID: 'SKU编号',
  listingID: 'Listing编号',
  vendorProductID: '供应商货号',
  fulfillType: '履约类型',
  productName: '商品名称',
  paymentType: '支付类型',
  fullyPrepaid: '全额在线支付',
  partialPrepaid: '部分在线支付',
  payOnDelivery: '货到付款',
  paymentStatus: '支付状态',
  unpaid: '未支付',
  paid: '已支付',
  resetFilter: '重置各筛选项',
  export: '导出订单',
  fold: '折叠',
  more: '更多',
  batchOperation: '批量操作',
  dispatch: '发货',
  printWaybill: '打印运单',
  orderAmount: '订单金额',
  skus: '商品种数',
  qty: '件数',
  operation: '操作',
  product: '商品',
  variant: '规格',
  unitPrice: '单价',
  detail: '详情',
  printList: '打印清单',
  trackOrder: '跟踪订单',
  deleted: '已删除',
  logisticsInformation: '物流信息',
  trackNo: '运单编号',
  trackNumber: '运单编号',
  close: '关闭',
  deliveryAddress: '配送地址',
  parcel: '包裹',
  orderInformation: '订单信息',
  orderStatus: '订单状态',
  updateTime: '更新时间',
  kindsOfSKU: '商品种数',
  totalQuantity: '总件数',
  buyerName: '买家姓名',
  paymentInformation: '支付信息',
  productAmount: '商品金额',
  shippingFee: '运费金额',
  sellerVoucherRedeemed: '卖家券抵扣',
  platformVoucherRedeemed: '平台券抵扣',
  coinRedeemed: '积分抵扣',
  paidAmount: '买家已支付金额',
  dueAmount: '待买家支付金额',
  productInformation: '商品信息',
  printPackingList: '打印清单',
  totalPrice: '总价',
  discount: '折扣金额',
  gift: '礼品',
  customCode: '海关编码',
  customCodeName: '海关商品名',
  customCodeAttribute: '商品申报要素',
  customDeclaredValue: '申报价值(元人民币)',
  customCodeNameCN: '中文品名',
  operationLog: '操作日志',
  operationType: '操作类型',
  from: '角色',
  operatorID: '操作帐号',
  dispatchingPanel: '发货面板',
  deliverTo: '配送地址',
  dispatchFrom: '发货地址',
  logisticsMethod: '物流方式',
  deliverByPlatformLogistics: '平台物流交付',
  fulfillByMyself: '卖家自己交付',
  firstMileMethod: '首公里方式',
  dropOffStation: '揽收点',
  usePlatformPackingService: '使用代打包服务？',
  yes: '是',
  no: '否',
  confirmToDispatch: '确认发货',
  orderDetail: '订单详情',
  buyerPayableAmount: '买家应付金额',
  discountTip: '分摊到该商品上的直接折扣金额。不包括优惠券或者积分的抵扣，仅与店铺参与的折扣活动有关 (如满减活动)。',
  senderName: '发件人姓名',
  senderPhone: '发件人电话号码',
  region: '地区',
  address: '地址',
  editDispatchAddress: '编辑发货地址',
  back: '返回',
  submit: '提交',
  cancelOrder: '取消订单',
  orderConfirmed: '确认订单',
  copyTip: '已成功复制',
  show: '展示',
  hide: '隐藏',
  productAmountTip: '减去直接折扣额（不包括优惠券抵扣或积分抵扣）后的商品总金额。',
  shippingFeeTip: '减去直接折扣额（不包括运费券抵扣）后的运费总金额。',
  selectReason: '选择原因',
  edit: '编辑',
  deliverToDropOffStation: '配送至揽收点',
  waybillNumber: '运单编号',
  status: '订单状态',
  sender: '发货地址',
  reason: '原因',
  viewReason: '查看原因',
  orderCancellationDetials: '订单取消详情',
  forWhatReason: '什么原因？',
  whoCancelledThisOrder: '谁取消了订单?',
  iAmAware: '我已知晓',
  reasonRole1: '买家',
  reasonRole2: '卖家',
  reasonRole3: '平台客服',
  reasonRole9: '平台系统',
  buyerUnpaid: '买家未支付'
}
